export default __webpack_public_path__ + "static/media/p_icon1.f880bb02.svg";